export const actionTypes = {
  CONFIGURATIONS_OFFICES_REQUEST: "CONFIGURATIONS_OFFICES_REQUEST",
  CONFIGURATIONS_OFFICES_REQUEST_SUCCESS:
    "CONFIGURATIONS_OFFICES_REQUEST_SUCCESS",
  CONFIGURATIONS_OFFICES_REQUEST_FAILURE:
    "CONFIGURATIONS_OFFICES_REQUEST_FAILURE",
  CONFIGURATIONS_OU_ENRICHMENTS_REQUEST:
    "CONFIGURATIONS_OU_ENRICHMENTS_REQUEST",
  CONFIGURATIONS_OU_ENRICHMENTS_REQUEST_SUCCESS:
    "CONFIGURATIONS_OU_ENRICHMENTS_REQUEST_SUCCESS",
  CONFIGURATIONS_OU_ENRICHMENTS_REQUEST_FAILURE:
    "CONFIGURATIONS_OU_ENRICHMENTS_REQUEST_FAILURE",
  CONFIGURATIONS_SOCIETIES_REQUEST: "CONFIGURATIONS_SOCIETIES_REQUEST",
  CONFIGURATIONS_SOCIETIES_REQUEST_SUCCESS:
    "CONFIGURATIONS_SOCIETIES_REQUEST_SUCCESS",
  CONFIGURATIONS_SOCIETIES_REQUEST_FAILURE:
    "CONFIGURATIONS_SOCIETIES_REQUEST_FAILURE",
  CONFIGURATIONS_ORGANIZATIONAL_UNITS_REQUEST:
    "CONFIGURATIONS_ORGANIZATIONAL_UNITS_REQUEST",
  CONFIGURATIONS_ORGANIZATIONAL_UNITS_REQUEST_SUCCESS:
    "CONFIGURATIONS_ORGANIZATIONAL_UNITS_REQUEST_SUCCESS",
  CONFIGURATIONS_ORGANIZATIONAL_UNITS_REQUEST_FAILURE:
    "CONFIGURATIONS_ORGANIZATIONAL_UNITS_REQUEST_FAILURE",
  CONFIGURATIONS_ATTRIBUTES_REQUEST: "CONFIGURATIONS_ATTRIBUTES_REQUEST",
  CONFIGURATIONS_ATTRIBUTES_REQUEST_SUCCESS:
    "CONFIGURATIONS_ATTRIBUTES_REQUEST_SUCCESS",
  CONFIGURATIONS_ATTRIBUTES_REQUEST_FAILURE:
    "CONFIGURATIONS_ATTRIBUTES_REQUEST_FAILURE",
  CONFIGURATIONS_COUNTERS_REQUEST: "CONFIGURATIONS_COUNTERS_REQUEST",
  CONFIGURATIONS_COUNTERS_REQUEST_SUCCESS:
    "CONFIGURATIONS_COUNTERS_REQUEST_SUCCESS",
  CONFIGURATIONS_COUNTERS_REQUEST_FAILURE:
    "CONFIGURATIONS_COUNTERS_REQUEST_FAILURE",
  CONFIGURATIONS_CONFIGURATIONS_REQUEST:
    "CONFIGURATIONS_CONFIGURATIONS_REQUEST",
  CONFIGURATIONS_CONFIGURATIONS_REQUEST_SUCCESS:
    "CONFIGURATIONS_CONFIGURATIONS_REQUEST_SUCCESS",
  CONFIGURATIONS_CONFIGURATIONS_REQUEST_FAILURE:
    "CONFIGURATIONS_CONFIGURATIONS_REQUEST_FAILURE",
  CONFIGURATIONS_OU_ENRICHMENTS_BY_ID_REQUEST:
    "CONFIGURATIONS_OU_ENRICHMENTS_BY_ID_REQUEST",
  CONFIGURATIONS_OU_ENRICHMENTS_BY_ID_REQUEST_SUCCESS:
    "CONFIGURATIONS_OU_ENRICHMENTS_BY_ID_REQUEST_SUCCESS",
  CONFIGURATIONS_OU_ENRICHMENTS_BY_ID_REQUEST_FAILURE:
    "CONFIGURATIONS_OU_ENRICHMENTS_BY_ID_REQUEST_FAILURE",
  CONFIGURATIONS_OFFICES_BY_ID_REQUEST: "CONFIGURATIONS_OFFICES_BY_ID_REQUEST",
  CONFIGURATIONS_OFFICES_BY_ID_REQUEST_SUCCESS:
    "CONFIGURATIONS_OFFICES_BY_ID_REQUEST_SUCCESS",
  CONFIGURATIONS_OFFICES_BY_ID_REQUEST_FAILURE:
    "CONFIGURATIONS_OFFICES_BY_ID_REQUEST_FAILURE",
  CONFIGURATIONS_SOCIETIES_BY_ID_REQUEST:
    "CONFIGURATIONS_SOCIETIES_BY_ID_REQUEST",
  CONFIGURATIONS_SOCIETIES_BY_ID_REQUEST_SUCCESS:
    "CONFIGURATIONS_SOCIETIES_BY_ID_REQUEST_SUCCESS",
  CONFIGURATIONS_SOCIETIES_BY_ID_REQUEST_FAILURE:
    "CONFIGURATIONS_SOCIETIES_BY_ID_REQUEST_FAILURE",
  CONFIGURATIONS_ORGANIZATIONAL_UNITS_BY_ID_REQUEST:
    "CONFIGURATIONS_ORGANIZATIONAL_UNITS_BY_ID_REQUEST",
  CONFIGURATIONS_ORGANIZATIONAL_UNITS_BY_ID_REQUEST_SUCCESS:
    "CONFIGURATIONS_ORGANIZATIONAL_UNITS_BY_ID_REQUEST_SUCCESS",
  CONFIGURATIONS_ORGANIZATIONAL_UNITS_BY_ID_REQUEST_FAILURE:
    "CONFIGURATIONS_ORGANIZATIONAL_UNITS_BY_ID_REQUEST_FAILURE",
  CONFIGURATIONS_ATTRIBUTES_BY_ID_REQUEST:
    "CONFIGURATIONS_ATTRIBUTES_BY_ID_REQUEST",
  CONFIGURATIONS_ATTRIBUTES_BY_ID_REQUEST_SUCCESS:
    "CONFIGURATIONS_ATTRIBUTES_BY_ID_REQUEST_SUCCESS",
  CONFIGURATIONS_ATTRIBUTES_BY_ID_REQUEST_FAILURE:
    "CONFIGURATIONS_ATTRIBUTES_BY_ID_REQUEST_FAILURE",
  CONFIGURATIONS_COUNTERS_BY_ID_REQUEST:
    "CONFIGURATIONS_COUNTERS_BY_ID_REQUEST",
  CONFIGURATIONS_COUNTERS_BY_ID_REQUEST_SUCCESS:
    "CONFIGURATIONS_COUNTERS_BY_ID_REQUEST_SUCCESS",
  CONFIGURATIONS_COUNTERS_BY_ID_REQUEST_FAILURE:
    "CONFIGURATIONS_COUNTERS_BY_ID_REQUEST_FAILURE",
  CREATE_OU_ENRICHMENT_REQUEST: "CREATE_OU_ENRICHMENT_REQUEST",
  CREATE_OU_ENRICHMENT_REQUEST_SUCCESS: "CREATE_OU_ENRICHMENT_REQUEST_SUCCESS",
  CREATE_OU_ENRICHMENT_REQUEST_FAILURE: "CREATE_OU_ENRICHMENT_REQUEST_FAILURE",
  CREATE_OFFICE_REQUEST: "CREATE_OFFICE_REQUEST",
  CREATE_OFFICE_REQUEST_SUCCESS: "CREATE_OFFICE_REQUEST_SUCCESS",
  CREATE_OFFICE_REQUEST_FAILURE: "CREATE_OFFICE_REQUEST_FAILURE",
  CREATE_SOCIETY_REQUEST: "CREATE_SOCIETY_REQUEST",
  CREATE_SOCIETY_REQUEST_SUCCESS: "CREATE_SOCIETY_REQUEST_SUCCESS",
  CREATE_SOCIETY_REQUEST_FAILURE: "CREATE_SOCIETY_REQUEST_FAILURE",
  CREATE_ATTRIBUTE_REQUEST: "CREATE_ATTRIBUTE_REQUEST",
  CREATE_ATTRIBUTE_REQUEST_SUCCESS: "CREATE_ATTRIBUTE_REQUEST_SUCCESS",
  CREATE_ATTRIBUTE_REQUEST_FAILURE: "CREATE_ATTRIBUTE_REQUEST_FAILURE",
  CREATE_COUNTER_REQUEST: "CREATE_COUNTER_REQUEST",
  CREATE_COUNTER_REQUEST_SUCCESS: "CREATE_COUNTER_REQUEST_SUCCESS",
  CREATE_COUNTER_REQUEST_FAILURE: "CREATE_COUNTER_REQUEST_FAILURE",
  UPDATE_OU_ENRICHMENT_REQUEST: "UPDATE_OU_ENRICHMENT_REQUEST",
  UPDATE_OU_ENRICHMENT_REQUEST_SUCCESS: "UPDATE_OU_ENRICHMENT_REQUEST_SUCCESS",
  UPDATE_OU_ENRICHMENT_REQUEST_FAILURE: "UPDATE_OU_ENRICHMENT_REQUEST_FAILURE",
  UPDATE_OFFICE_REQUEST: "UPDATE_OFFICE_REQUEST",
  UPDATE_OFFICE_REQUEST_SUCCESS: "UPDATE_OFFICE_REQUEST_SUCCESS",
  UPDATE_OFFICE_REQUEST_FAILURE: "UPDATE_OFFICE_REQUEST_FAILURE",
  UPDATE_SOCIETY_REQUEST: "UPDATE_SOCIETY_REQUEST",
  UPDATE_SOCIETY_REQUEST_SUCCESS: "UPDATE_SOCIETY_REQUEST_SUCCESS",
  UPDATE_SOCIETY_REQUEST_FAILURE: "UPDATE_SOCIETY_REQUEST_FAILURE",
  UPDATE_ATTRIBUTE_REQUEST: "UPDATE_ATTRIBUTE_REQUEST",
  UPDATE_ATTRIBUTE_REQUEST_SUCCESS: "UPDATE_ATTRIBUTE_REQUEST_SUCCESS",
  UPDATE_ATTRIBUTE_REQUEST_FAILURE: "UPDATE_ATTRIBUTE_REQUEST_FAILURE",
  UPDATE_COUNTER_REQUEST: "UPDATE_COUNTER_REQUEST",
  UPDATE_COUNTER_REQUEST_SUCCESS: "UPDATE_COUNTER_REQUEST_SUCCESS",
  UPDATE_COUNTER_REQUEST_FAILURE: "UPDATE_COUNTER_REQUEST_FAILURE",
  UPDATE_CONFIGURATION_REQUEST: "UPDATE_CONFIGURATION_REQUEST",
  UPDATE_CONFIGURATION_REQUEST_SUCCESS: "UPDATE_CONFIGURATION_REQUEST_SUCCESS",
  UPDATE_CONFIGURATION_REQUEST_FAILURE: "UPDATE_CONFIGURATION_REQUEST_FAILURE",
  DELETE_OU_ENRICHMENT_REQUEST: "DELETE_OU_ENRICHMENT_REQUEST",
  DELETE_OU_ENRICHMENT_REQUEST_SUCCESS: "DELETE_OU_ENRICHMENT_REQUEST_SUCCESS",
  DELETE_OU_ENRICHMENT_REQUEST_FAILURE: "DELETE_OU_ENRICHMENT_REQUEST_FAILURE",
  DELETE_OFFICE_REQUEST: "DELETE_OFFICE_REQUEST",
  DELETE_OFFICE_REQUEST_SUCCESS: "DELETE_OFFICE_REQUEST_SUCCESS",
  DELETE_OFFICE_REQUEST_FAILURE: "DELETE_OFFICE_REQUEST_FAILURE",
  DELETE_SOCIETY_REQUEST: "DELETE_SOCIETY_REQUEST",
  DELETE_SOCIETY_REQUEST_SUCCESS: "DELETE_SOCIETY_REQUEST_SUCCESS",
  DELETE_SOCIETY_REQUEST_FAILURE: "DELETE_SOCIETY_REQUEST_FAILURE",
  DELETE_ATTRIBUTE_REQUEST: "DELETE_ATTRIBUTE_REQUEST",
  DELETE_ATTRIBUTE_REQUEST_SUCCESS: "DELETE_ATTRIBUTE_REQUEST_SUCCESS",
  DELETE_ATTRIBUTE_REQUEST_FAILURE: "DELETE_ATTRIBUTE_REQUEST_FAILURE",
  DELETE_COUNTER_REQUEST: "DELETE_COUNTER_REQUEST",
  DELETE_COUNTER_REQUEST_SUCCESS: "DELETE_COUNTER_REQUEST_SUCCESS",
  DELETE_COUNTER_REQUEST_FAILURE: "DELETE_COUNTER_REQUEST_FAILURE",
  DELETE_CONFIGURATION_REQUEST: "DELETE_CONFIGURATION_REQUEST",
  DELETE_CONFIGURATION_REQUEST_SUCCESS: "DELETE_CONFIGURATION_REQUEST_SUCCESS",
  DELETE_CONFIGURATION_REQUEST_FAILURE: "DELETE_CONFIGURATION_REQUEST_FAILURE",
  GET_CONSOLE_ADMIN_FIELD_VISIBILITY: "GET_CONSOLE_ADMIN_FIELD_VISIBILITY",
  GET_CONSOLE_ADMIN_FIELD_VISIBILITY_SUCCESS:
    "GET_CONSOLE_ADMIN_FIELD_VISIBILITY_SUCCESS",
  GET_CONSOLE_ADMIN_FIELD_VISIBILITY_FAILURE:
    "GET_CONSOLE_ADMIN_FIELD_VISIBILITY_FAILURE",
  UPDATE_FIELD_VISIBILITY: "UPDATE_FIELD_VISIBILITY",
  UPDATE_FIELD_VISIBILITY_SUCCESS: "UPDATE_FIELD_VISIBILITY_SUCCESS",
  UPDATE_FIELD_VISIBILITY_FAILURE: "UPDATE_FIELD_VISIBILITY_FAILURE",
  GET_EXTERNAL_PORTAL_ROLES: "GET_EXTERNAL_PORTAL_ROLES",
  GET_EXTERNAL_PORTAL_ROLES_SUCCESS: "GET_EXTERNAL_PORTAL_ROLES_SUCCESS",
  GET_EXTERNAL_PORTAL_ROLES_FAILURE: "GET_EXTERNAL_PORTAL_ROLES_FAILURE",
  SELECT_ROLE: "SELECT_ROLE",
  GET_BUTTONS_BY_ROLE: "GET_BUTTONS_BY_ROLE",
  GET_BUTTONS_BY_ROLE_SUCCESS: "GET_BUTTONS_BY_ROLE_SUCCESS",
  GET_BUTTONS_BY_ROLE_FAILURE: "GET_BUTTONS_BY_ROLE_FAILURE",
  MANAGEMENT_BUTTONS_BY_ROLE: "MANAGEMENT_BUTTONS_BY_ROLE",
  MANAGEMENT_BUTTONS_BY_ROLE_SUCCESS: "MANAGEMENT_BUTTONS_BY_ROLE_SUCCESS",
  MANAGEMENT_BUTTONS_BY_ROLE_FAILURE: "MANAGEMENT_BUTTONS_BY_ROLE_FAILURE",
  RESET_BUTTONS: "RESET_BUTTONS",
  RESET_STATE_EXTERNAL_PORTAL_MANAGEMENT:
    "RESET_STATE_EXTERNAL_PORTAL_MANAGEMENT",
};

export const configurationsOUEnrichmentsRequest = () => ({
  type: actionTypes.CONFIGURATIONS_OU_ENRICHMENTS_REQUEST,
});

export const configurationsOUEnrichmentsRequestSuccess = (payload: any[]) => ({
  type: actionTypes.CONFIGURATIONS_OU_ENRICHMENTS_REQUEST_SUCCESS,
  payload,
});

export const configurationsOUEnrichmentsRequestFailure = (err: Error) => ({
  type: actionTypes.CONFIGURATIONS_OU_ENRICHMENTS_REQUEST_FAILURE,
  err,
});

export const configurationsConfigurationsRequest = () => ({
  type: actionTypes.CONFIGURATIONS_CONFIGURATIONS_REQUEST,
});

export const configurationsConfigurationsRequestSuccess = (payload: any[]) => ({
  type: actionTypes.CONFIGURATIONS_CONFIGURATIONS_REQUEST_SUCCESS,
  payload,
});

export const configurationsConfigurationsRequestFailure = (err: Error) => ({
  type: actionTypes.CONFIGURATIONS_CONFIGURATIONS_REQUEST_FAILURE,
  err,
});

export const configurationsOfficesRequest = () => ({
  type: actionTypes.CONFIGURATIONS_OFFICES_REQUEST,
});

export const configurationsOfficesRequestSuccess = (payload: any[]) => ({
  type: actionTypes.CONFIGURATIONS_OFFICES_REQUEST_SUCCESS,
  payload,
});

export const configurationsOfficesRequestFailure = (err: Error) => ({
  type: actionTypes.CONFIGURATIONS_OFFICES_REQUEST_FAILURE,
  err,
});

export const configurationsSocietiesRequest = () => ({
  type: actionTypes.CONFIGURATIONS_SOCIETIES_REQUEST,
});

export const configurationsSocietiesRequestSuccess = (payload: any[]) => ({
  type: actionTypes.CONFIGURATIONS_SOCIETIES_REQUEST_SUCCESS,
  payload,
});

export const configurationsSocietiesRequestFailure = (err: Error) => ({
  type: actionTypes.CONFIGURATIONS_SOCIETIES_REQUEST_FAILURE,
  err,
});

export const configurationsOrganizationalUnitsRequest = () => ({
  type: actionTypes.CONFIGURATIONS_ORGANIZATIONAL_UNITS_REQUEST,
});

export const configurationsOrganizationalUnitsRequestSuccess = (
  payload: any[]
) => ({
  type: actionTypes.CONFIGURATIONS_ORGANIZATIONAL_UNITS_REQUEST_SUCCESS,
  payload,
});

export const configurationsOrganizationalUnitsRequestFailure = (
  err: Error
) => ({
  type: actionTypes.CONFIGURATIONS_ORGANIZATIONAL_UNITS_REQUEST_FAILURE,
  err,
});

export const configurationsAttributesRequest = () => ({
  type: actionTypes.CONFIGURATIONS_ATTRIBUTES_REQUEST,
});

export const configurationsAttributesRequestSuccess = (payload: any[]) => ({
  type: actionTypes.CONFIGURATIONS_ATTRIBUTES_REQUEST_SUCCESS,
  payload,
});

export const configurationsAttributesRequestFailure = (err: Error) => ({
  type: actionTypes.CONFIGURATIONS_ATTRIBUTES_REQUEST_FAILURE,
  err,
});

export const configurationsCountersRequest = () => ({
  type: actionTypes.CONFIGURATIONS_COUNTERS_REQUEST,
});

export const configurationsCountersRequestSuccess = (payload: any[]) => ({
  type: actionTypes.CONFIGURATIONS_COUNTERS_REQUEST_SUCCESS,
  payload,
});

export const configurationsCountersRequestFailure = (err: Error) => ({
  type: actionTypes.CONFIGURATIONS_COUNTERS_REQUEST_FAILURE,
  err,
});

export const configurationsOUEnrichmentsByIdRequest = (payload: any) => ({
  type: actionTypes.CONFIGURATIONS_OU_ENRICHMENTS_BY_ID_REQUEST,
  payload,
});

export const configurationsOUEnrichmentsByIdRequestSuccess = (
  payload: any[]
) => ({
  type: actionTypes.CONFIGURATIONS_OU_ENRICHMENTS_BY_ID_REQUEST_SUCCESS,
  payload,
});

export const configurationsOUEnrichmentsByIdRequestFailure = (err: Error) => ({
  type: actionTypes.CONFIGURATIONS_OU_ENRICHMENTS_BY_ID_REQUEST_FAILURE,
  err,
});

export const configurationsOfficesByIdRequest = (payload: any) => ({
  type: actionTypes.CONFIGURATIONS_OFFICES_BY_ID_REQUEST,
  payload,
});

export const configurationsOfficesByIdRequestSuccess = (payload: any[]) => ({
  type: actionTypes.CONFIGURATIONS_OFFICES_BY_ID_REQUEST_SUCCESS,
  payload,
});

export const configurationsOfficesByIdRequestFailure = (err: Error) => ({
  type: actionTypes.CONFIGURATIONS_OFFICES_BY_ID_REQUEST_FAILURE,
  err,
});

export const configurationsSocietiesByIdRequest = (payload: any) => ({
  type: actionTypes.CONFIGURATIONS_SOCIETIES_BY_ID_REQUEST,
  payload,
});

export const configurationsSocietiesByIdRequestSuccess = (payload: any[]) => ({
  type: actionTypes.CONFIGURATIONS_SOCIETIES_BY_ID_REQUEST_SUCCESS,
  payload,
});

export const configurationsSocietiesByIdRequestFailure = (err: Error) => ({
  type: actionTypes.CONFIGURATIONS_SOCIETIES_BY_ID_REQUEST_FAILURE,
  err,
});

export const configurationsOrganizationalUnitsByIdRequest = (payload: any) => ({
  type: actionTypes.CONFIGURATIONS_ORGANIZATIONAL_UNITS_BY_ID_REQUEST,
  payload,
});

export const configurationsOrganizationalUnitsByIdRequestSuccess = (
  payload: any[]
) => ({
  type: actionTypes.CONFIGURATIONS_ORGANIZATIONAL_UNITS_BY_ID_REQUEST_SUCCESS,
  payload,
});

export const configurationsOrganizationalUnitsByIdRequestFailure = (
  err: Error
) => ({
  type: actionTypes.CONFIGURATIONS_ORGANIZATIONAL_UNITS_BY_ID_REQUEST_FAILURE,
  err,
});

export const configurationsAttributesByIdRequest = (payload: any) => ({
  type: actionTypes.CONFIGURATIONS_ATTRIBUTES_BY_ID_REQUEST,
  payload,
});

export const configurationsAttributesByIdRequestSuccess = (payload: any[]) => ({
  type: actionTypes.CONFIGURATIONS_ATTRIBUTES_BY_ID_REQUEST_SUCCESS,
  payload,
});

export const configurationsAttributesByIdRequestFailure = (err: Error) => ({
  type: actionTypes.CONFIGURATIONS_ATTRIBUTES_BY_ID_REQUEST_FAILURE,
  err,
});

export const configurationsCountersByIdRequest = (payload: any) => ({
  type: actionTypes.CONFIGURATIONS_COUNTERS_BY_ID_REQUEST,
  payload,
});

export const configurationsCountersByIdRequestSuccess = (payload: any[]) => ({
  type: actionTypes.CONFIGURATIONS_COUNTERS_BY_ID_REQUEST_SUCCESS,
  payload,
});

export const configurationsCountersByIdRequestFailure = (err: Error) => ({
  type: actionTypes.CONFIGURATIONS_COUNTERS_BY_ID_REQUEST_FAILURE,
  err,
});

export const createConfigurationsOUEnrichmentRequest = (payload: any) => ({
  type: actionTypes.CREATE_OU_ENRICHMENT_REQUEST,
  payload,
});

export const createConfigurationsOUEnrichmentRequestSuccess = (
  payload: any[]
) => ({
  type: actionTypes.CREATE_OU_ENRICHMENT_REQUEST_SUCCESS,
  payload,
});

export const createConfigurationsOUEnrichmentRequestFailure = (err: Error) => ({
  type: actionTypes.CREATE_OU_ENRICHMENT_REQUEST_FAILURE,
  err,
});

export const createConfigurationsOfficeRequest = (payload: any) => ({
  type: actionTypes.CREATE_OFFICE_REQUEST,
  payload,
});

export const createConfigurationsOfficeRequestSuccess = (payload: any[]) => ({
  type: actionTypes.CREATE_OFFICE_REQUEST_SUCCESS,
  payload,
});

export const createConfigurationsOfficeRequestFailure = (err: Error) => ({
  type: actionTypes.CREATE_OFFICE_REQUEST_FAILURE,
  err,
});

export const createConfigurationsSocietyRequest = (payload: any) => ({
  type: actionTypes.CREATE_SOCIETY_REQUEST,
  payload,
});

export const createConfigurationsSocietyRequestSuccess = (payload: any[]) => ({
  type: actionTypes.CREATE_SOCIETY_REQUEST_SUCCESS,
  payload,
});

export const createConfigurationsSocietyRequestFailure = (err: Error) => ({
  type: actionTypes.CREATE_SOCIETY_REQUEST_FAILURE,
  err,
});

export const createConfigurationsAttributeRequest = (payload: any) => ({
  type: actionTypes.CREATE_ATTRIBUTE_REQUEST,
  payload,
});

export const createConfigurationsAttributeRequestSuccess = (
  payload: any[]
) => ({
  type: actionTypes.CREATE_ATTRIBUTE_REQUEST_SUCCESS,
  payload,
});

export const createConfigurationsAttributeRequestFailure = (err: Error) => ({
  type: actionTypes.CREATE_ATTRIBUTE_REQUEST_FAILURE,
  err,
});

export const createConfigurationsCounterRequest = (payload: any) => ({
  type: actionTypes.CREATE_COUNTER_REQUEST,
  payload,
});

export const createConfigurationsCounterRequestSuccess = (payload: any[]) => ({
  type: actionTypes.CREATE_COUNTER_REQUEST_SUCCESS,
  payload,
});

export const createConfigurationsCounterRequestFailure = (err: Error) => ({
  type: actionTypes.CREATE_COUNTER_REQUEST_FAILURE,
  err,
});

export const updateConfigurationsOUEnrichmentRequest = (payload: any) => ({
  type: actionTypes.UPDATE_OU_ENRICHMENT_REQUEST,
  payload,
});

export const updateConfigurationsOUEnrichmentRequestSuccess = (
  payload: any[]
) => ({
  type: actionTypes.UPDATE_OU_ENRICHMENT_REQUEST_SUCCESS,
  payload,
});

export const updateConfigurationsOUEnrichmentRequestFailure = (err: Error) => ({
  type: actionTypes.UPDATE_OU_ENRICHMENT_REQUEST_FAILURE,
  err,
});

export const updateConfigurationsOfficeRequest = (payload: any) => ({
  type: actionTypes.UPDATE_OFFICE_REQUEST,
  payload,
});

export const updateConfigurationsOfficeRequestSuccess = (payload: any[]) => ({
  type: actionTypes.UPDATE_OFFICE_REQUEST_SUCCESS,
  payload,
});

export const updateConfigurationsOfficeRequestFailure = (err: Error) => ({
  type: actionTypes.UPDATE_OFFICE_REQUEST_FAILURE,
  err,
});

export const updateConfigurationsSocietyRequest = (payload: any) => ({
  type: actionTypes.UPDATE_SOCIETY_REQUEST,
  payload,
});

export const updateConfigurationsSocietyRequestSuccess = (payload: any[]) => ({
  type: actionTypes.UPDATE_SOCIETY_REQUEST_SUCCESS,
  payload,
});

export const updateConfigurationsSocietyRequestFailure = (err: Error) => ({
  type: actionTypes.UPDATE_SOCIETY_REQUEST_FAILURE,
  err,
});

export const updateConfigurationsAttributeRequest = (payload: any) => ({
  type: actionTypes.UPDATE_ATTRIBUTE_REQUEST,
  payload,
});

export const updateConfigurationsAttributeRequestSuccess = (
  payload: any[]
) => ({
  type: actionTypes.UPDATE_ATTRIBUTE_REQUEST_SUCCESS,
  payload,
});

export const updateConfigurationsAttributeRequestFailure = (err: Error) => ({
  type: actionTypes.UPDATE_ATTRIBUTE_REQUEST_FAILURE,
  err,
});

export const updateConfigurationsCounterRequest = (payload: any) => ({
  type: actionTypes.UPDATE_COUNTER_REQUEST,
  payload,
});

export const updateConfigurationsCounterRequestSuccess = (payload: any[]) => ({
  type: actionTypes.UPDATE_COUNTER_REQUEST_SUCCESS,
  payload,
});

export const updateConfigurationsCounterRequestFailure = (err: Error) => ({
  type: actionTypes.UPDATE_COUNTER_REQUEST_FAILURE,
  err,
});

export const updateConfigurationsConfigurationRequest = (payload: any) => ({
  type: actionTypes.UPDATE_CONFIGURATION_REQUEST,
  payload,
});

export const updateConfigurationsConfigurationRequestSuccess = (
  payload: any[]
) => ({
  type: actionTypes.UPDATE_CONFIGURATION_REQUEST_SUCCESS,
  payload,
});

export const updateConfigurationsConfigurationRequestFailure = (
  err: Error
) => ({
  type: actionTypes.UPDATE_CONFIGURATION_REQUEST_FAILURE,
  err,
});

export const deleteConfigurationsOUEnrichmentRequest = (payload: any) => ({
  type: actionTypes.DELETE_OU_ENRICHMENT_REQUEST,
  payload,
});

export const deleteConfigurationsOUEnrichmentRequestSuccess = (
  payload: any[]
) => ({
  type: actionTypes.DELETE_OU_ENRICHMENT_REQUEST_SUCCESS,
  payload,
});

export const deleteConfigurationsOUEnrichmentRequestFailure = (err: Error) => ({
  type: actionTypes.DELETE_OU_ENRICHMENT_REQUEST_FAILURE,
  err,
});

export const deleteConfigurationsOfficeRequest = (payload: any) => ({
  type: actionTypes.DELETE_OFFICE_REQUEST,
  payload,
});

export const deleteConfigurationsOfficeRequestSuccess = (payload: any[]) => ({
  type: actionTypes.DELETE_OFFICE_REQUEST_SUCCESS,
  payload,
});

export const deleteConfigurationsOfficeRequestFailure = (err: Error) => ({
  type: actionTypes.DELETE_OFFICE_REQUEST_FAILURE,
  err,
});

export const deleteConfigurationsSocietyRequest = (payload: any) => ({
  type: actionTypes.DELETE_SOCIETY_REQUEST,
  payload,
});

export const deleteConfigurationsSocietyRequestSuccess = (payload: any[]) => ({
  type: actionTypes.DELETE_SOCIETY_REQUEST_SUCCESS,
  payload,
});

export const deleteConfigurationsSocietyRequestFailure = (err: Error) => ({
  type: actionTypes.DELETE_SOCIETY_REQUEST_FAILURE,
  err,
});

export const deleteConfigurationsAttributeRequest = (payload: any) => ({
  type: actionTypes.DELETE_ATTRIBUTE_REQUEST,
  payload,
});

export const deleteConfigurationsAttributeRequestSuccess = (
  payload: any[]
) => ({
  type: actionTypes.DELETE_ATTRIBUTE_REQUEST_SUCCESS,
  payload,
});

export const deleteConfigurationsAttributeRequestFailure = (err: Error) => ({
  type: actionTypes.DELETE_ATTRIBUTE_REQUEST_FAILURE,
  err,
});

export const deleteConfigurationsCounterRequest = (payload: any) => ({
  type: actionTypes.DELETE_COUNTER_REQUEST,
  payload,
});

export const deleteConfigurationsCounterRequestSuccess = (payload: any[]) => ({
  type: actionTypes.DELETE_COUNTER_REQUEST_SUCCESS,
  payload,
});

export const deleteConfigurationsCounterRequestFailure = (err: Error) => ({
  type: actionTypes.DELETE_COUNTER_REQUEST_FAILURE,
  err,
});

export const deleteConfigurationsConfigurationRequest = (payload: any) => ({
  type: actionTypes.DELETE_CONFIGURATION_REQUEST,
  payload,
});

export const deleteConfigurationsConfigurationRequestSuccess = (
  payload: any[]
) => ({
  type: actionTypes.DELETE_CONFIGURATION_REQUEST_SUCCESS,
  payload,
});

export const deleteConfigurationsConfigurationRequestFailure = (
  err: Error
) => ({
  type: actionTypes.DELETE_CONFIGURATION_REQUEST_FAILURE,
  err,
});

export const getRoles = () => ({
  type: actionTypes.GET_EXTERNAL_PORTAL_ROLES,
});

export const getRolesSuccess = (payload: any[]) => ({
  type: actionTypes.GET_EXTERNAL_PORTAL_ROLES_SUCCESS,
  payload,
});

export const getRolesFailure = (err: Error) => ({
  type: actionTypes.GET_EXTERNAL_PORTAL_ROLES_FAILURE,
  err,
});

export const selectRole = (payload: any) => ({
  type: actionTypes.SELECT_ROLE,
  payload,
});

export const getFieldVisibility = () => ({
  type: actionTypes.GET_CONSOLE_ADMIN_FIELD_VISIBILITY,
});

export const getFieldVisibilitySuccess = (payload: any[]) => ({
  type: actionTypes.GET_CONSOLE_ADMIN_FIELD_VISIBILITY_SUCCESS,
  payload,
});

export const getFieldVisibilityFailure = (err: Error) => ({
  type: actionTypes.GET_CONSOLE_ADMIN_FIELD_VISIBILITY_FAILURE,
  err,
});

export const updateFieldVisibility = (payload: any) => ({
  type: actionTypes.UPDATE_FIELD_VISIBILITY,
  payload,
});

export const updateFieldVisibilitySuccess = (payload: any[]) => ({
  type: actionTypes.UPDATE_FIELD_VISIBILITY_SUCCESS,
  payload,
});

export const updateFieldVisibilityFailure = (err: Error) => ({
  type: actionTypes.UPDATE_FIELD_VISIBILITY_FAILURE,
  err,
});

export const getButtonsByRole = (payload: any) => ({
  type: actionTypes.GET_BUTTONS_BY_ROLE,
  payload,
});

export const getButtonsByRoleSuccess = (payload: any[]) => ({
  type: actionTypes.GET_BUTTONS_BY_ROLE_SUCCESS,
  payload,
});

export const getButtonsByRoleFailure = (err: Error) => ({
  type: actionTypes.GET_BUTTONS_BY_ROLE_FAILURE,
  err,
});

export const managementButtonsByRole = (payload: any) => ({
  type: actionTypes.MANAGEMENT_BUTTONS_BY_ROLE,
  payload,
});

export const managementButtonsByRoleSuccess = (payload: any[]) => ({
  type: actionTypes.MANAGEMENT_BUTTONS_BY_ROLE_SUCCESS,
  payload,
});

export const managementButtonsByRoleFailure = (err: Error) => ({
  type: actionTypes.MANAGEMENT_BUTTONS_BY_ROLE_FAILURE,
  err,
});

export const resetButtons = () => ({
  type: actionTypes.RESET_BUTTONS,
});

export const resetState = () => ({
  type: actionTypes.RESET_STATE_EXTERNAL_PORTAL_MANAGEMENT,
});
